export const ReadOnlyValueQcFieldName = 'readOnlyValueQcFieldComponent';
